import React from "react";
import Select from 'react-select';
import i18n from "../../../../i18n";
import { Clock, Search, TrendingUp, X } from "lucide-react";
import { HomeBanner } from "../../homeBanner";
import { getAllAuctions, searchAuctions } from "../../../../models/auctions";
import { getCategories, getCategoriesNew } from "../../../../models/categories";
import { getOrganizations } from "../../../../models/organization";
import { CustomTitle } from "../../../helpers/customTitle";
import Lightbox from "react-awesome-lightbox";
import { Pagination } from "react-bootstrap";
import { MzadLoader } from "../../../helpers/mzadLoader";
import { AuctionRowGrouped } from "../../helpers/auctionRowGrouped";
import { AuctionCard } from "../../helpers/auctionCard";


let current_lng = localStorage.getItem('I18N_LANGUAGE');
const CalendarIcon = () => {
  return (
    <span className="date-icon">
      <i className="mdi mdi-calendar text-success" />
    </span>
  );
};
const ClearIcon = () => {
  return <fa className="mdi mdi-close" />;
};
export class Auctions extends React.Component {
  constructor() {
    super();
    this.state = {
      total: 0,
      pagination: {
        limit: 30,
        page: 1,
      },
      catArrs: [],
      subCatArrs: [],
      categories: [],
      selectedCategories: [],
      orgArrs: [],
      organizations: [],
      auctions: [],
      is_loading: false,
      is_cat_loading: false,
      lightboxImages: [],
      is_active_light_box: false,
      grid: false,
      section: '',
      type: '',
      category: '',
      organization: '',
      expand_orgs: false,
      expand_cats: false,
      input: {
        search_text: '',
        organization: '',
        fdate: '',
        tdate: ''
      },
      startDate: "",
      endDate: "",
      vehicle_categories: [],
      isOpen: false,
      expandedSections: {
        category: true,
        vehicleType: true,
        make: false,
        model: false,
        endDate: false,
        odometer: false,
        priceRange: false,
        yearRange: false
      },
      searchSuggestions: [],
      showSuggestions: false,
      searchTimeout: null,
      recentSearches: [],
      popularSearches: ['car', 'electronics', 'furniture', 'real estate', 'jewelry'],
      isSearchFocused: false
    };
    this.getAllAuctionsList = this.getAllAuctionsList.bind(this);
    this.getImagePopup = this.getImagePopup.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
    this.createCategory = this.createCategory.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleSearchInputChange = this.handleSearchInputChange.bind(this);
    this.handleSuggestionClick = this.handleSuggestionClick.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    let urlSearchParams = new URLSearchParams(window.location.search);
    let params = Object.fromEntries(urlSearchParams.entries());
    this.loadAllCategories(params);
    this.loadAllOrganizations(params);
    this.getAllAuctionsList(params);
    if (params.sec === 'vehicle') {
      this.loadVehicleCategories();
    }

    // Load recent searches from localStorage
    const savedRecentSearches = localStorage.getItem('recentSearches');
    if (savedRecentSearches) {
      this.setState({ recentSearches: JSON.parse(savedRecentSearches) });
    }

    // Add click outside listener to close suggestions
    document.addEventListener('click', this.handleClickOutside);
  }

  componentWillUnmount() {
    // Clean up the event listener
    document.removeEventListener('click', this.handleClickOutside);
    if (this.state.searchTimeout) {
      clearTimeout(this.state.searchTimeout);
    }
  }

  handleClickOutside = (e) => {
    if (!e.target.closest('.search-container')) {
      this.setState({
        showSuggestions: false,
        isSearchFocused: false
      });
    }
  };

  handleChange(event) {
    let input = this.state.input;
    input[event.target.name] = event.target.value;
    this.setState({ input });
  }

  handleDateChange(date, name) {
    let input = this.state.input;
    if (date) {
      const dateObject = new Date(date);
      const day = dateObject.getDate();
      const month = dateObject.getMonth() + 1;
      const year = dateObject.getFullYear();
      const formattedDay = day < 10 ? `0${day}` : day;
      const formattedMonth = month < 10 ? `0${month}` : month;
      const formattedDate = `${year}-${formattedMonth}-${formattedDay}`.toString();
      input[name] = formattedDate;
      this.setState({ input, [name]: date });
    } else {
      input[name] = '';
      this.setState({ input, [name]: null });
    }
  }

  handleSearchInputChange = (e) => {
    const value = e.target.value;
    let input = this.state.input;
    input.search_text = value;
    this.setState({ input });

    // Clear existing timeout
    if (this.state.searchTimeout) {
      clearTimeout(this.state.searchTimeout);
    }

    if (value.length > 0) {
      // Show suggestions immediately when typing starts
      this.setState({ showSuggestions: true });

      if (value.length > 1) {
        // Set new timeout for debouncing API calls
        const timeout = setTimeout(() => {
          this.fetchSearchSuggestions(value);
        }, 200);

        this.setState({ searchTimeout: timeout });
      } else {
        // Clear API suggestions but keep dropdown open for recent/popular searches
        this.setState({ searchSuggestions: [] });
      }
    } else {
      this.setState({
        searchSuggestions: [],
        showSuggestions: this.state.isSearchFocused // Keep open if focused but empty
      });
    }
  };

  fetchSearchSuggestions = async (query) => {
    try {
      const response = await searchAuctions(`text=${query}&limit=8&lang=${current_lng}`);
      if (response && response.data) {
        this.setState({
          searchSuggestions: response.data
        });
      }
    } catch (error) {
      console.error('Error fetching search suggestions:', error);
      this.setState({
        searchSuggestions: []
      });
    }
  };

  handleSuggestionClick = (suggestion, type = 'auction') => {
    let searchText = '';

    if (type === 'auction') {
      searchText = suggestion.title || suggestion.title_ar;
    } else if (type === 'recent') {
      searchText = suggestion;
    } else if (type === 'popular') {
      searchText = suggestion;
    }

    let input = this.state.input;
    input.search_text = searchText;

    // Add to recent searches
    this.addToRecentSearches(searchText);

    this.setState({
      input,
      showSuggestions: false,
      searchSuggestions: [],
      isSearchFocused: false
    }, () => {
      this.applyFilters();
    });
  };

  addToRecentSearches = (searchTerm) => {
    const recentSearches = [...this.state.recentSearches];

    // Remove if already exists
    const existingIndex = recentSearches.indexOf(searchTerm);
    if (existingIndex > -1) {
      recentSearches.splice(existingIndex, 1);
    }

    // Add to beginning
    recentSearches.unshift(searchTerm);

    // Keep only last 5 searches
    const updatedSearches = recentSearches.slice(0, 5);

    this.setState({ recentSearches: updatedSearches });
    localStorage.setItem('recentSearches', JSON.stringify(updatedSearches));
  };

  clearRecentSearches = () => {
    this.setState({ recentSearches: [] });
    localStorage.removeItem('recentSearches');
  };

  handleSearch = (e) => {
    if (e.key === 'Enter' || e.type === 'click') {
      if (this.state.input.search_text.trim()) {
        this.addToRecentSearches(this.state.input.search_text.trim());
      }

      this.setState({
        showSuggestions: false,
        searchSuggestions: [],
        isSearchFocused: false
      });
      this.applyFilters();
    }
  };

  handleSearchFocus = () => {
    this.setState({
      isSearchFocused: true,
      showSuggestions: true
    });
  };

  handleSearchBlur = () => {
    // Delay hiding to allow for clicks on suggestions
    setTimeout(() => {
      if (!this.state.isSearchFocused) {
        this.setState({ showSuggestions: false });
      }
    }, 200);
  };

  async loadAllCategories(params) {
    this.setState({ is_cat_loading: true });
    if (typeof params.category !== 'undefined') {
      var category = params.category;
      this.setState({
        catArrs: [parseInt(category)],
        selectedCategories: [parseInt(category)]
      });
    }
    const response = await getCategoriesNew('active=1');
    if (response) {
      let categories = response.data;
      console.log(categories);
      this.setState({ categories });
      this.setState({ is_cat_loading: false });
    }
  }

  async loadVehicleCategories() {
    const response = await getCategories('vehicles=1');
    if (response) {
      let vehicle_categories = response.data;
      this.setState({ vehicle_categories });
    }
  }

  async loadAllOrganizations(params) {
    this.setState({ is_org_loading: true });
    if (typeof params.organization !== 'undefined') {
      var org = params.organization;
      this.setState({
        orgArrs: [parseInt(org)],
        input: {
          ...this.state.input,
          organization: org
        }
      });
    }
    let q = params.type === 'active' ? 'is_active=1' : '';
    const response = await getOrganizations(q);
    if (response) {
      let organizations = response.data;
      this.setState({ organizations });
      this.setState({ is_org_loading: false });
    }
  }

  async getAllAuctionsList(params = {}) {
    this.setState({ is_loading: true });
    let q = '';

    // Use params from function call or fall back to state
    const section = params.sec || this.state.section;
    const type = params.type || this.state.type;
    const category = params.category || this.state.category;
    const organization = params.organization || this.state.input.organization;
    const search_text = params.search_text || this.state.input.search_text;

    if (typeof this.state.pagination.limit !== 'undefined') {
      q += 'limit=' + this.state.pagination.limit;
    }
    if (typeof this.state.pagination.page !== 'undefined') {
      q += '&page=' + this.state.pagination.page;
    }
    if (section) {
      q += '&section=' + section;
    }
    if (type) {
      q += '&type=' + type;
    }
    if (category) {
      q += '&category=' + category;
    }
    if (organization) {
      q += '&organization=' + organization;
    }
    if (search_text) {
      q += '&text=' + encodeURIComponent(search_text);
    }
    q += '&lang=' + current_lng;

    let { fdate, tdate } = this.state.input;
    if (fdate) {
      q += '&fdate=' + fdate;
    }
    if (tdate) {
      q += '&tdate=' + tdate;
    }

    this.setState({
      section: section,
      type: type,
      category: category,
    });

    const response = await getAllAuctions(q);
    if (response) {
      let { meta, data } = response;
      this.setState({
        auctions: data,
        is_loading: false,
        total: meta.total
      });
    }
  }

  createCategory(id, sub = false) {
    if (sub) {
      var subCatArrs = this.state.catArrs;
      if (subCatArrs.includes(id)) {
        const index = subCatArrs.indexOf(parseInt(id));
        if (index > -1) {
          subCatArrs.splice(index, 1);
        }
      } else {
        subCatArrs.push(parseInt(id));
      }
      this.setState({ subCatArrs: subCatArrs });
      this.applyFilters();
    } else {
      if (!id) {
        this.setState({
          catArrs: [],
          selectedCategories: []
        });
        this.applyFilters();
        return;
      }
      var catArrs = this.state.catArrs;
      let selectedCategories = [...this.state.selectedCategories];

      if (catArrs.includes(id)) {
        const index = catArrs.indexOf(parseInt(id));
        if (index > -1) {
          catArrs.splice(index, 1);
        }
        // Also remove from selectedCategories for the filter panel
        const selectedIndex = selectedCategories.indexOf(parseInt(id));
        if (selectedIndex > -1) {
          selectedCategories.splice(selectedIndex, 1);
        }
      } else {
        catArrs.push(parseInt(id));
        selectedCategories.push(parseInt(id));
      }
      this.setState({
        catArrs: catArrs,
        selectedCategories: selectedCategories
      });
      this.applyFilters();
    }
  }

  applyFilters() {
    var { type, section, pagination, input } = this.state;
    var { catArrs } = this.state;

    var cats = catArrs.join(',');
    if (catArrs.length < 1) {
      cats = '';
    }

    pagination.limit = 15;
    pagination.page = 1;
    this.setState({ pagination });

    this.setState({
      category: cats,
      vehicle_category: cats,
      type: type,
      section: section,
    });

    this.getAllAuctionsList({
      sec: section,
      type: type,
      category: cats,
      vehicle_category: cats,
      organization: input.organization,
      search_text: input.search_text,
    });

    // Close the filter panel and suggestions after applying
    this.setState({
      isOpen: false,
      showSuggestions: false,
      isSearchFocused: false
    });
  }

  getImagePopup(active, images) {
    let lightboxImages = [];
    if (images) {
      images.forEach(function (arrayItem) {
        lightboxImages.push({
          url: arrayItem.image,
        });
      });
      this.setState({
        is_active_light_box: active,
        lightboxImages: lightboxImages,
      });
    }
  }

  handlePageChange = (pageNumber) => {
    let { pagination } = this.state;
    pagination.page = pageNumber;
    this.setState({ pagination });
    this.getAllAuctionsList();
  };

  showResults = () => {
    const { startDate, endDate, selectedCategories } = this.state;

    // Update the category filter based on selected categories
    const cats = selectedCategories.join(',');

    // Update date filters
    const input = {
      ...this.state.input,
      fdate: startDate,
      tdate: endDate
    };

    this.setState({
      catArrs: selectedCategories,
      category: cats,
      input: input
    }, () => {
      this.applyFilters();
    });

    console.log({
      categories: selectedCategories,
      start_date: startDate,
      end_date: endDate,
    });
  }

  toggleFilter = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  toggleSection = (section) => {
    this.setState(prevState => ({
      expandedSections: {
        ...prevState.expandedSections,
        [section]: !prevState.expandedSections[section]
      }
    }));
  };

  handleCategoryChange = (categoryId) => {
  this.setState((prevState) => {
    const isSelected = prevState.selectedCategories.includes(categoryId);
    let newSelectedCategories;

    if (isSelected) {
      newSelectedCategories = prevState.selectedCategories.filter((id) => id !== categoryId);
    } else {
      newSelectedCategories = [...prevState.selectedCategories, categoryId];
    }

    // Also update catArrs for consistency with the existing filter system
    const newCatArrs = newSelectedCategories;
    
    return {
      selectedCategories: newSelectedCategories,
      catArrs: newCatArrs
    };
  }, () => {
    // This callback runs after state is updated
    this.applyFilters();
  });
};

  clearAllFilters = () => {
    this.setState({
      selectedCategories: [],
      catArrs: [],
      startDate: "",
      endDate: "",
      input: {
        ...this.state.input,
        fdate: '',
        tdate: '',
        search_text: '',
        organization: ''
      },
      searchSuggestions: [],
      showSuggestions: false,
      isSearchFocused: false
    }, () => {
      this.applyFilters();
    });
  };

  render() {
    let { categories, vehicle_categories, organizations, auctions, catArrs, subCatArrs, isOpen, expandedSections, selectedCategories, searchSuggestions, showSuggestions, recentSearches, popularSearches, isSearchFocused, input } = this.state;
    const styles = {
      overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 1000,
        display: isOpen ? 'flex' : 'none',
        justifyContent: 'flex-start',
        alignItems: 'stretch'
      },
      filterPanel: {
        width: '550pxpx',
        backgroundColor: 'white',
        height: '100vh',
        overflowY: 'auto',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
      },
      header: {
        padding: '20px 24px',
        borderBottom: '1px solid #e5e7eb',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: '#f8fafc'
      },
      title: {
        fontSize: '24px',
        fontWeight: '700',
        color: '#1f2937',
        margin: 0
      },
      closeButton: {
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        padding: '4px',
        borderRadius: '4px',
        color: '#6b7280'
      },
      sidebar: {
        backgroundColor: '#f8fafc',
        borderRight: '1px solid #e5e7eb'
      },
      sidebarItem: {
        padding: '12px 24px',
        cursor: 'pointer',
        borderBottom: '1px solid #e5e7eb',
        fontSize: '14px',
        color: '#6b7280',
        transition: 'all 0.2s ease'
      },
      sidebarItemActive: {
        backgroundColor: 'white',
        color: '#1f2937',
        fontWeight: '500',
        borderRight: '3px solid #189397'
      },
      content: {
        flex: 1,
        padding: '24px'
      },
      section: {
        marginBottom: '24px',
        borderBottom: '1px solid #f1f5f9',
        paddingBottom: '20px'
      },
      sectionHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        cursor: 'pointer',
        marginBottom: '16px'
      },
      sectionTitle: {
        fontSize: '16px',
        fontWeight: '600',
        color: '#1f2937',
        margin: 0
      },
      categoryGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '8px'
      },
      categoryButton: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 12px',
        border: '1px solid #d1d5db',
        borderRadius: '6px',
        backgroundColor: 'white',
        cursor: 'pointer',
        fontSize: '13px',
        transition: 'all 0.2s ease'
      },
      categoryButtonActive: {
        backgroundColor: '#fee2e2',
        borderColor: '#189397',
        color: '#189397'
      },
      searchBox: {
        position: 'relative',
        marginBottom: '12px'
      },
      searchInput: {
        width: '100%',
        padding: '8px 12px 8px 36px',
        border: '1px solid #d1d5db',
        borderRadius: '6px',
        fontSize: '14px'
      },
      searchIcon: {
        position: 'absolute',
        left: '12px',
        top: '50%',
        transform: 'translateY(-50%)',
        color: '#9ca3af'
      },
      checkboxList: {
        maxHeight: '200px',
        overflowY: 'auto'
      },
      checkboxItem: {
        display: 'flex',
        alignItems: 'center',
        padding: '6px 0',
        fontSize: '14px'
      },
      checkbox: {
        marginRight: '8px',
        cursor: 'pointer'
      },
      rangeInputs: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '8px'
      },
      rangeInput: {
        padding: '8px 12px',
        border: '1px solid #d1d5db',
        borderRadius: '6px',
        fontSize: '14px'
      },
      footer: {
        padding: '16px 24px',
        borderTop: '1px solid #e5e7eb',
        backgroundColor: '#f8fafc',
        display: 'flex',
        gap: '12px',
      },
      clearButton: {
        flex: 1,
        padding: '10px 16px',
        border: '1px solid #d1d5db',
        borderRadius: '6px',
        backgroundColor: 'white',
        color: '#6b7280',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: '500'
      },
      saveButton: {
        flex: 1,
        padding: '10px 16px',
        border: 'none',
        borderRadius: '6px',
        backgroundColor: '#6b7280',
        color: 'white',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: '500'
      },
      showButton: {
        flex: 2,
        padding: '10px 16px',
        border: 'none',
        borderRadius: '6px',
        backgroundColor: '#189397',
        color: 'white',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: '500'
      },
      toggleButton: {
        position: 'fixed',
        top: '50%',
        left: isOpen ? '400px' : '20px',
        transform: 'translateY(-50%)',
        padding: '12px',
        backgroundColor: '#189397',
        color: 'white',
        border: 'none',
        borderRadius: '0 6px 6px 0',
        cursor: 'pointer',
        zIndex: 1001,
        fontSize: '14px',
        fontWeight: '600',
        transition: 'all 0.3s ease'
      },
      dateInput: {
        padding: "8px 10px",
        borderRadius: "8px",
        border: "1px solid #ccc",
        fontSize: "14px",
        outline: "none",
        transition: "border-color 0.2s ease",
      },
      searchContainer: {
        position: 'relative',
        width: '100%'
      },
      suggestionsDropdown: {
        position: 'absolute',
        top: '100%',
        left: 0,
        right: 0,
        backgroundColor: 'white',
        border: '1px solid #e5e7eb',
        borderRadius: '0 0 12px 12px',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        zIndex: 1000,
        maxHeight: '400px',
        overflowY: 'auto',
        marginTop: '0'
      },
      suggestionSection: {
        padding: '12px 0',
        borderBottom: '1px solid #f3f4f6'
      },
      sectionHeader: {
        padding: '0 0px 8px 0px',
        fontSize: '14px',
        fontWeight: '600',
        color: '#6b7280',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
      },
      suggestionItem: {
        padding: '12px 16px',
        cursor: 'pointer',
        fontSize: '14px',
        color: '#374151',
        transition: 'background-color 0.2s ease',
        display: 'flex',
        alignItems: 'center',
        gap: '12px'
      },
      suggestionItemHover: {
        backgroundColor: '#f8fafc'
      },
      suggestionTitle: {
        fontWeight: '500',
        marginBottom: '2px'
      },
      suggestionDetails: {
        fontSize: '12px',
        color: '#6b7280',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      },
      noSuggestions: {
        padding: '20px 16px',
        fontSize: '14px',
        color: '#6b7280',
        textAlign: 'center'
      },
      searchIcon: {
        color: '#9ca3af',
        width: '16px',
        height: '16px'
      },
      recentSearchIcon: {
        color: '#6b7280',
        width: '16px',
        height: '16px'
      },
      trendingIcon: {
        color: '#ef4444',
        width: '16px',
        height: '16px'
      },
      clearButton: {
        background: 'none',
        border: 'none',
        color: '#189397',
        fontSize: '12px',
        cursor: 'pointer',
        marginLeft: 'auto'
      },
      searchInputContainer: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        width: '100%'
      },
      searchInput: {
        width: '100%',
        padding: '12px 16px 12px 40px',
        border: '2px solid #e5e7eb',
        borderRadius: '24px',
        fontSize: '16px',
        outline: 'none',
        transition: 'all 0.3s ease'
      },
      searchInputFocused: {
        borderColor: '#189397',
        boxShadow: '0 0 0 3px rgba(24, 147, 151, 0.1)'
      },
      searchInputIcon: {
        position: 'absolute',
        left: '16px',
        color: '#9ca3af',
        width: '18px',
        height: '18px'
      },
      searchActionIcon: {
        position: 'absolute',
        right: '16px',
        color: '#189397',
        width: '18px',
        height: '18px',
        cursor: 'pointer'
      },
      auctionImage: {
        width: '40px',
        height: '40px',
        borderRadius: '6px',
        objectFit: 'cover'
      },
      priceTag: {
        backgroundColor: '#189397',
        color: 'white',
        padding: '2px 6px',
        borderRadius: '4px',
        fontSize: '11px',
        fontWeight: '600'
      }
    };
    const hasSearchText = input.search_text.length > 0;
    const showRecentSearches = !hasSearchText && recentSearches.length > 0;
    const showPopularSearches = !hasSearchText && popularSearches.length > 0;
    const showAuctionResults = hasSearchText && searchSuggestions.length > 0;

    return (
      <React.Fragment>

        {/* Filter Panel - keep existing */}
        <div style={styles.overlay} onClick={(e) => e.target === e.currentTarget && this.toggleFilter()}>
          <div style={styles.filterPanel}>
            <div style={styles.header}>
              <h2 style={styles.title}>Filters</h2>
              <button style={styles.closeButton} onClick={this.toggleFilter}>
                <X size={24} />
              </button>
            </div>

            <div style={{ display: 'flex', height: 'calc(100vh - 140px)' }}>


              <div style={styles.content}>

                <div style={styles.section}>
                  <div style={styles.sectionHeader}>
                    <h3 style={styles.sectionTitle}>Category</h3>
                    {/* <ChevronUp size={20} color="#6b7280" /> */}
                  </div>

                  <div style={styles.categoryGrid}>
                    {categories.map(category => (
                      <button
                        key={category.id}
                        style={{
                          ...styles.categoryButton,
                          ...(selectedCategories.includes(category.id)
                            ? styles.categoryButtonActive
                            : {}),
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: "10px 10px",
                          borderRadius: "10px",
                          border: "1px solid #ddd",
                          background: selectedCategories.includes(category.id)
                            ? "#f5f5f5"
                            : "#fff",
                          cursor: "pointer",
                          gap: "10px",
                          minWidth: "200px",
                        }}
                        onClick={() => this.handleCategoryChange(category.id)}
                      >
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          {/* <span style={{ fontSize: "16px" }}>{category.icon}</span> */}
                          <span style={{ fontWeight: 500 }}>
                            {current_lng === "ar"
                              ? category.category_name_ar
                              : category.category_name}
                          </span>
                        </div>

                        <span style={{ color: "#888", fontSize: "14px" }}>
                          ({category.auctions_count})
                        </span>
                      </button>
                    ))}
                  </div>
                </div>


                <div style={styles.section}>
                  <div style={styles.sectionHeader}>
                    <h3 style={styles.sectionTitle}>Date Range</h3>
                  </div>


                  <div style={styles.categoryGrid}>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label style={{ marginBottom: "6px", color: "#555", fontWeight: 500, fontSize: "12px" }}>
                        Start Date
                      </label>
                      <input
                        type="date"
                        value={this.state.startDate}
                        onChange={(e) => this.setState({ startDate: e.target.value })}
                        style={styles.dateInput}
                      />
                    </div>

                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label style={{ marginBottom: "6px", color: "#555", fontWeight: 500, fontSize: "12px" }}>
                        End Date
                      </label>
                      <input
                        type="date"
                        value={this.state.endDate}
                        onChange={(e) => this.setState({ endDate: e.target.value })}
                        style={styles.dateInput}
                      />
                    </div>
                  </div>


                </div>

                <div style={styles.section}>
                  <div style={styles.sectionHeader}>
                    <h3 style={styles.sectionTitle}>{i18n.t('seller')}</h3>
                  </div>

                  <Select
                    isMulti
                    name="group"
                    id="groupSelect"
                    style={styles.dateInput}
                    options={organizations.map((item) => ({
                      value: item.id,
                      label: item.organization_name
                    }))}
                    value={
                      (this.state.input.group || []).map((id) => {
                        const g = organizations.find((item) => item.id === id);
                        return g
                          ? { value: g.id, label: g.organization_name }
                          : null;
                      }).filter(Boolean)
                    }
                    onChange={(selected) => {
                      this.setState((prevState) => ({
                        input: {
                          ...prevState.input,
                          group: selected ? selected.map((opt) => opt.value) : []
                        }
                      }));
                    }}
                    classNamePrefix="select"
                    placeholder={i18n.t('select_seller')}
                  />
                </div>

              </div>
            </div>

            <div style={styles.footer}>
              <button style={styles.clearButton} onClick={this.clearAllFilters}>
                Clear All
              </button>
              <button style={styles.showButton} onClick={this.showResults}>
                Show Results
              </button>
            </div>
          </div>
        </div>

        <HomeBanner callbackForSupport={this.props.callbackForSupport} />

        <div className="row overflow-hidden" id="auctions-list">
          <div className="section-title center-block text-center auction-list-section">
            <CustomTitle
              title={
                this.state.type === 'active' ? i18n.t('active_auctions') :
                  this.state.type === 'upcoming' ? i18n.t('upcoming_auctions') :
                    this.state.type === 'previous' ? i18n.t('previous_auctions') :
                      this.state.type === 'featured' ? i18n.t('featured_auctions') :
                        (this.state.section === 'main' && typeof this.state.type === 'undefined') ? i18n.t('auctions') :
                          this.state.section === 'vehicle' ? i18n.t('vehicle_auctions') :
                            ''
              }
              icon="ri_auction-fill.png"
              icon_type="img"
              count={this.state.total}
              need_mzad_icon={true}
            />
          </div>

          <section className="sptb mt-3">
            <div className="container">
              <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className=" mb-0">
                    <div className>
                      <div className="item2-gl " id="auction-grouped">

                        <div className="button-sort-section m-auto" style={{ width: '100%' }}>
                          <div className="dropdown search-section-dropdown">
                            <button
                              className="btn btn-secondary dropdown-toggle burger-menu"
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              onClick={() => {
                                this.setState({
                                  show_cat_dd: !this.state.show_cat_dd,
                                });
                              }}
                            >
                              <img
                                src={process.env.PUBLIC_URL + '/assets/images/burger menu.png'}
                                width="30"
                                alt=""
                              />
                            </button>
                            <ul
                              className={
                                this.state.show_cat_dd ? 'dropdown-menu d-block' : 'dropdown-menu'
                              }
                            >
                              {categories.map((item, i) => {
                                return (
                                  <li key={item.id}>
                                    <a
                                      className={
                                        catArrs.includes(item.id)
                                          ? 'dropdown-item active'
                                          : 'dropdown-item'
                                      }
                                      href="#"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        this.createCategory(item.id);
                                        this.setState({
                                          show_cat_dd: false,
                                        });
                                      }}
                                    >
                                      {current_lng === 'ar'
                                        ? item.category_name_ar
                                        : item.category_name}
                                    </a>
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                          <div className="buttons-section justify-content-start">
                            <button
                              className="sort-button sbtn-1"
                              onClick={this.toggleFilter}
                            >
                              <i className="fa fa-filter" width="20" style={{ color: "white" }}> </i>
                            </button>
                            All Filters
                          </div>
                          <div className="sort-section">
                            <div className="search-container" style={styles.searchContainer}>
                              <div style={styles.searchInputContainer}>
                                <Search style={styles.searchInputIcon} />
                                <input
                                  type="text"
                                  name="search_text"
                                  placeholder={i18n.t('search_by_name_loc_seller')}
                                  value={this.state.input.search_text}
                                  onChange={this.handleSearchInputChange}
                                  onKeyPress={this.handleSearch}
                                  onFocus={this.handleSearchFocus}
                                  onBlur={this.handleSearchBlur}
                                  style={{
                                    ...styles.searchInput,
                                    ...(isSearchFocused ? styles.searchInputFocused : {})
                                  }}
                                />
                                {input.search_text && (
                                  <Search
                                    style={styles.searchActionIcon}
                                    onClick={this.handleSearch}
                                  />
                                )}
                              </div>

                              {/* Google-like Search Suggestions Dropdown */}
                              {showSuggestions && isSearchFocused && (
                                <div style={styles.suggestionsDropdown}>
                                  {/* Auction Results */}
                                  {showAuctionResults && (
                                    <div style={styles.suggestionSection}>
                                      <div style={styles.sectionHeader}>
                                        <Search style={styles.searchIcon} />
                                        Auction Results
                                      </div>
                                      {searchSuggestions.map((suggestion, index) => (
                                        <div
                                          key={suggestion.id || index}
                                          style={styles.suggestionItem}
                                          onClick={() => this.handleSuggestionClick(suggestion, 'auction')}
                                          onMouseEnter={(e) => {
                                            e.target.style.backgroundColor = '#f8fafc';
                                          }}
                                          onMouseLeave={(e) => {
                                            e.target.style.backgroundColor = 'white';
                                          }}
                                        >
                                          {suggestion.images && suggestion.images[0] && (
                                            <img
                                              src={suggestion.images[0].image}
                                              alt=""
                                              style={styles.auctionImage}
                                              onError={(e) => {
                                                e.target.style.display = 'none';
                                              }}
                                            />
                                          )}
                                          <div style={{ flex: 1 }}>
                                            <div style={styles.suggestionTitle}>
                                              {current_lng === 'ar' ? suggestion.title_ar : suggestion.title}
                                            </div>
                                            <div style={styles.suggestionDetails}>
                                              <span>
                                                {suggestion.category_name && (
                                                  current_lng === 'ar' ? suggestion.category_name_ar : suggestion.category_name
                                                )}
                                              </span>
                                              {suggestion.current_amount && (
                                                <span style={styles.priceTag}>
                                                  ${suggestion.current_amount}
                                                </span>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  )}

                                  {/* Recent Searches */}
                                  {showRecentSearches && (
                                    <div style={styles.suggestionSection}>
                                      <div style={styles.sectionHeader}>
                                        <Clock style={styles.recentSearchIcon} />
                                        Recent Searches
                                        <button
                                          style={styles.clearButton}
                                          onClick={this.clearRecentSearches}
                                        >
                                          Clear
                                        </button>
                                      </div>
                                      {recentSearches.map((search, index) => (
                                        <div
                                          key={index}
                                          style={styles.suggestionItem}
                                          onClick={() => this.handleSuggestionClick(search, 'recent')}
                                          onMouseEnter={(e) => {
                                            e.target.style.backgroundColor = '#f8fafc';
                                          }}
                                          onMouseLeave={(e) => {
                                            e.target.style.backgroundColor = 'white';
                                          }}
                                        >
                                          <Clock style={styles.recentSearchIcon} />
                                          {search}
                                        </div>
                                      ))}
                                    </div>
                                  )}

                                  {/* Popular Searches */}
                                  {showPopularSearches && (
                                    <div style={styles.suggestionSection}>
                                      <div style={styles.sectionHeader}>
                                        <TrendingUp style={styles.trendingIcon} />
                                        Popular Searches
                                      </div>
                                      {popularSearches.map((search, index) => (
                                        <div
                                          key={index}
                                          style={styles.suggestionItem}
                                          onClick={() => this.handleSuggestionClick(search, 'popular')}
                                          onMouseEnter={(e) => {
                                            e.target.style.backgroundColor = '#f8fafc';
                                          }}
                                          onMouseLeave={(e) => {
                                            e.target.style.backgroundColor = 'white';
                                          }}
                                        >
                                          <TrendingUp style={styles.trendingIcon} />
                                          {search}
                                        </div>
                                      ))}
                                    </div>
                                  )}

                                  {/* No Results */}
                                  {hasSearchText && searchSuggestions.length === 0 && (
                                    <div style={styles.noSuggestions}>
                                      No results found for "{input.search_text}"
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                            <button
                              className={
                                this.state.grid
                                  ? 'sort-button sbtn-1 d-mob-none'
                                  : 'sort-button sbtn-2 d-mob-none'
                              }
                              onClick={() => {
                                this.setState({ grid: true });
                              }}
                            >
                              <img
                                src={process.env.PUBLIC_URL + '/assets/images/grid.png'}
                                width="20"
                                alt="sort"
                                className={this.state.grid ? 'grid-invert' : ''}
                              />
                            </button>
                            <button
                              className={
                                !this.state.grid
                                  ? 'sort-button sbtn-1 d-mob-none'
                                  : 'sort-button sbtn-2 d-mob-none'
                              }
                              onClick={() => {
                                this.setState({ grid: false });
                              }}
                            >
                              <img
                                src={process.env.PUBLIC_URL + '/assets/images/burger menu.png'}
                                width="20"
                                alt="sort"
                                className={!this.state.grid ? '' : 'grid-invert'}
                              />
                            </button>
                          </div>
                        </div>

                        {/* Rest of your existing auction listing code remains the same */}
                        <div className="tab-content rounded-4 mb-3 mt-3">
                          <div className="tab-pane active" id="tab-11">
                            <MzadLoader loading={this.state.is_loading} size="md" />
                            <div>
                              {!this.state.is_loading &&
                                !this.state.grid &&
                                auctions.length > 0 &&
                                auctions.map((item, i) => {
                                  let _data = {
                                    auction: item,
                                    auctionId: item.id,
                                    total_items: auctions.length,
                                    company: 'Mzadcom',
                                    price: item.start_amount,
                                    title: item.title,
                                    title_ar: item.title_ar,
                                    description: 'Diesel Generators',
                                    curr_amount: item.current_amount,
                                    end_date: item.end_date_formatted,
                                    start_date: item.start_date_formatted,
                                    images: item.images,
                                    total_views: item.total_views,
                                    type: this.state.type,
                                    can_bid: false,
                                    status: item.status,
                                  };

                                  return (
                                    <AuctionRowGrouped
                                      key={i}
                                      {..._data}
                                      getImagePopup={this.getImagePopup}
                                    />
                                  );
                                })}
                            </div>

                            <div className="row">
                              {!this.state.is_loading &&
                                this.state.grid &&
                                auctions.length > 0 &&
                                auctions.map((item, i) => {
                                  let _data = {
                                    auction: item,
                                    auctionId: item.id,
                                    total_items: auctions.length,
                                    company: 'Mzadcom',
                                    price: item.start_amount,
                                    title: item.title,
                                    title_ar: item.title_ar,
                                    description: 'Diesel Generators',
                                    curr_amount: item.current_amount,
                                    end_date: item.end_date_formatted,
                                    start_date: item.start_date_formatted,
                                    images: item.images,
                                    total_views: item.total_views,
                                    type: this.state.type,
                                    can_bid: false,
                                    status: item.status,
                                  };

                                  return (
                                    <div className="col-md-4" key={i}>
                                      <AuctionCard
                                        {..._data}
                                        getImagePopup={this.getImagePopup}
                                        isDetailsPage={true}
                                      />
                                    </div>
                                  );
                                })}
                            </div>

                            {!this.state.is_loading && !auctions.length && (
                              <div className="help text-danger text-center">
                                {i18n.t('no_auctions_found')}
                              </div>
                            )}
                          </div>
                        </div>
                        {this.state.total > this.state.pagination.limit && (
                          <div>
                            <Pagination
                              currentPage={this.state.pagination.page}
                              totalPages={Math.ceil(this.state.total / this.state.pagination.limit)}
                              onPageChange={this.handlePageChange}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        {this.state.is_active_light_box && (
          <Lightbox
            images={this.state.lightboxImages}
            onClose={() => {
              this.setState({ is_active_light_box: false });
            }}
          />
        )}
      </React.Fragment>
    );
  }
}